import * as ActionTypes from '../actions/ActionTypes';
export const authInitialState = {
  gates: [],
  scopes: [],
  user: {
    created_at: 0,
    email: '',
    emails: [],
    first_name: '',
    last_name: '',
    lang_enabled: false,
    locale: '',
    partner: false,
    roles: [],
    scopes: [],
    teams: [],
    user_id: 0,
    verified: false
  },
  portal: {
    created_at: 0,
    enabled_gates: [],
    expired: false,
    expired_at: 0,
    family_id: 0,
    friends_and_family: false,
    partner: false,
    portal_id: 0,
    product_id: 0,
    product_type: '',
    timezone: {
      id: '0',
      offset: 0,
      'moment-data': ''
    },
    trial: false,
    limits: {}
  }
};
export default function Auth(state = authInitialState, action) {
  switch (action.type) {
    case ActionTypes.APP_STARTED:
      return {
        gates: action.gates,
        scopes: action.user.scopes,
        user: action.user,
        portal: action.portal
      };
    default:
      return state;
  }
}